import * as i0 from '@angular/core';
import { Injectable, Component, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

class EIPToastAlertService {
    constructor() { }
}
EIPToastAlertService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EIPToastAlertService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class EIPToastAlertComponent {
    constructor(data, _snackBar) {
        this.data = data;
        this._snackBar = _snackBar;
        this.durationInSeconds = 250;
        this.messageLength = 98;
        this.messageTitle = '';
        this.text_truncate = function (str, length) {
            if (length == null) {
                length = 100;
            }
            if (str.length > length) {
                return str.substring(0, length);
            }
            else {
                return str;
            }
        };
        //  this.title = data['_title']
        this.messageType = data['_messageType'];
        if (data['_messageLength']) {
            this.messageLength = data['_messageLength'];
        }
        else {
            this.messageLength = 98;
        }
        if (this.messageType === 'Success') {
            if (data['_messageTitle']) {
                this.messageTitle = data['_messageTitle'];
            }
            else {
                this.messageTitle = 'Success';
            }
        }
        if (this.messageType === 'Error') {
            if (data['_messageTitle']) {
                this.messageTitle = data['_messageTitle'];
            }
            else {
                this.messageTitle = 'Error';
            }
        }
        if (this.messageType === 'Warning') {
            if (data['_messageTitle']) {
                this.messageTitle = data['_messageTitle'];
            }
            else {
                this.messageTitle = 'Warning';
            }
        }
        if (this.messageType === 'Information') {
            if (data['_messageTitle']) {
                this.messageTitle = data['_messageTitle'];
            }
            else {
                this.messageTitle = 'Information';
            }
        }
        if (data['_message']) {
            this.message = this.text_truncate(data['_message'], this.messageLength);
        }
        else {
            this.message = '';
        }
    }
    ngOnInit() {
        const elem = document.getElementsByClassName('cdk-global-overlay-wrapper');
        if (elem && elem.length > 0) {
            elem[0].classList.add('eip-pointer-events-unset');
        }
    }
    close() {
        this._snackBar.dismiss();
    }
}
EIPToastAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertComponent, deps: [{ token: MAT_SNACK_BAR_DATA }, { token: i1.MatSnackBar }], target: i0.ɵɵFactoryTarget.Component });
EIPToastAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EIPToastAlertComponent, selector: "EIPToastAlert", ngImport: i0, template: "<div *ngIf=\"messageType == 'Success'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-check success\"></span>{{messageTitle}}\r\n  </h1>\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"messageType == 'Warning'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-exclamation-triangle warning\"></span>{{messageTitle}}\r\n  </h1>\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"messageType == 'Information'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-info information\"></span>{{messageTitle}}\r\n  </h1>\r\n\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"messageType == 'Error'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-times error\"></span>{{messageTitle}}\r\n  </h1>\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n", styles: ["::ng-deep .cdk-global-overlay-wrapper.eip-pointer-events-unset{pointer-events:unset!important}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPToastAlert', styles: [`::ng-deep .cdk-global-overlay-wrapper.eip-pointer-events-unset { 
    pointer-events: unset !important;
  }
`], template: "<div *ngIf=\"messageType == 'Success'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-check success\"></span>{{messageTitle}}\r\n  </h1>\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"messageType == 'Warning'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-exclamation-triangle warning\"></span>{{messageTitle}}\r\n  </h1>\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"messageType == 'Information'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-info information\"></span>{{messageTitle}}\r\n  </h1>\r\n\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"messageType == 'Error'\">\r\n  <span class=\"fa fa-times toast-close\" title=\"close\" (click)=\"close()\"></span>\r\n  <h1 mat-dialog-title class=\"toast-title\">\r\n    <span class=\"fa fa-times error\"></span>{{messageTitle}}\r\n  </h1>\r\n  <div mat-dialog-content class=\"toast-content\">\r\n    <p class=\"toastMessageLength\">{{ message }}</p>\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_SNACK_BAR_DATA]
                    }] }, { type: i1.MatSnackBar }];
    } });

class EIPToastAlertModule {
}
EIPToastAlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPToastAlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertModule, declarations: [EIPToastAlertComponent], imports: [MatDialogModule, CommonModule, FormsModule, ReactiveFormsModule, MatSnackBarModule], exports: [EIPToastAlertComponent] });
EIPToastAlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertModule, imports: [[MatDialogModule, CommonModule, FormsModule, ReactiveFormsModule, MatSnackBarModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPToastAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPToastAlertComponent],
                    imports: [MatDialogModule, CommonModule, FormsModule, ReactiveFormsModule, MatSnackBarModule
                    ],
                    exports: [EIPToastAlertComponent]
                }]
        }] });

/*
 * Public API Surface of eiptoast-alert
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPToastAlertComponent, EIPToastAlertModule, EIPToastAlertService };
